var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTcIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 18,
    height: 18,
    fill: "#111"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clarity_truck-line",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M14.763,5.949H12.8V3.492A.491.491,0,0,0,12.306,3H1.492A.492.492,0,0,0,1,3.492v8.848a.491.491,0,0,0,.492.492h.492V3.983h9.831V9.734a3.2,3.2,0,0,1,.767-.1H12.8v-2.7h1.966a.983.983,0,0,1,.983.983v.492H13.78V9.39h1.966v2.458h-1.18a2.232,2.232,0,0,0-4.1,0H7.11a2.212,2.212,0,0,0-2.05-1.357,2.153,2.153,0,1,0,2.192,2.34h3.087a2.207,2.207,0,0,0,4.385,0h1.514a.491.491,0,0,0,.492-.492V7.915a1.966,1.966,0,0,0-1.966-1.966Zm-9.7,7.865a1.17,1.17,0,1,1,0-2.335,1.17,1.17,0,1,1,0,2.335Zm7.457,0a1.17,1.17,0,1,1,1.229-1.165,1.2,1.2,0,0,1-1.229,1.165Z",
    transform: "translate(-0.017 -0.051)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcIcon);
export default __webpack_public_path__ + "static/media/tc-icon.91963815832a72035539072486f0e532.svg";
export { ForwardRef as ReactComponent };